import IframeService from '@/services/IframeDashboardService'

export const iframeDashboard = {
  namespaced: true,
  actions: {
    buscarUrlIframe ({ dispatch, commit }, { nome }) {
      return IframeService.getUrlIframe({ nome })
        .then(
          response => {
            return response
          },
          error => {
            commit('loading/forceEndLoading', null, { root: true })
            console.error(error)
            throw error
          }
        )
    },
    getUrlIframe ({ dispatch }, nome) {
      return IframeService.getUrlIframe({ nome })
        .then(
          response => {
            return response
          },
          error => {
            console.error(error)
            throw error
          }
        )
    },
    getAllIframes ({ dispatch }) {
      return IframeService.getAllIframes({ dispatch })
        .then(
          response => {
            return response
          },
          error => {
            console.error(error)
            throw error
          }
        )
    },
    putIframe ({ dispatch }, payload) {
      return IframeService.putIframe(payload)
        .then(
          response => {
            return response
          },
          error => {
            console.error(error)
            throw error
          }
        )
    },
    postIframeRetornar ({ dispatch }, payload) {
      return IframeService.postIframeRetornar(payload)
        .then(
          response => {
            return response
          },
          error => {
            console.error(error)
            throw error
          }
        )
    },
    deleteIframe ({ dispatch }, id) {
      return IframeService.deleteIframe(id)
        .then(
          response => {
            return response
          },
          error => {
            console.error(error)
            throw error
          }
        )
    },
    geIframeAuth ({ dispatch }, nome) {
      return IframeService.getIframeAuth({ nome })
        .then(
          response => {
            return response
          },
          error => {
            console.error(error)
            throw error
          }
        )
    },
    getAllIframesAuth ({ dispatch }) {
      return IframeService.getAllIframesAuth({ dispatch })
        .then(
          response => {
            return response
          },
          error => {
            console.error(error)
            throw error
          }
        )
    },
    putIframeAuth ({ dispatch }, payload) {
      return IframeService.putIframeAuth(payload)
        .then(
          response => {
            return response
          },
          error => {
            console.error(error)
            throw error
          }
        )
    },
    postIframeAuthRetornar ({ dispatch }, payload) {
      return IframeService.postIframeAuthRetornar(payload)
        .then(
          response => {
            return response
          },
          error => {
            console.error(error)
            throw error
          }
        )
    },
    deleteIframeAuth ({ dispatch }, id) {
      return IframeService.deleteIframeAuth(id)
        .then(
          response => {
            return response
          },
          error => {
            console.error(error)
            throw error
          }
        )
    },
  },
  state: {},
  mutations: {},
}
